/* eslint-disable */
import React from 'react'
import {
  AvatarCell,
  SelectColumnFilter,
  StatusPill,
  UnixtimeDateCell,
} from '../Table'
import IconSvg from '../../svg/Svg'
import { CloudDownloadIcon } from '@heroicons/react/outline'

const data2 = [
  {
    name: 'Jane Cooper',
    email: 'jane.cooper@example.com',
    title: 'Regional Paradigm Technician',
    department: 'Optimization',
    status: 'Done',
    role: 'Admin',
    age: 27,
    imgUrl: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=4&w=256&h=256&q=60',
  },
  {
    name: 'Cody Fisher',
    email: 'cody.fisher@example.com',
    title: 'Product Directives Officer',
    department: 'Intranet',
    status: 'In progress',
    role: 'Owner',
    age: 43,
    imgUrl: 'https://images.unsplash.com/photo-1570295999919-56ceb5ecca61?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=4&w=256&h=256&q=60',
  },
  {
    name: 'Esther Howard',
    email: 'esther.howard@example.com',
    title: 'Forward Response Developer',
    department: 'Directives',
    status: 'Done',
    role: 'Member',
    age: 32,
    imgUrl: 'https://images.unsplash.com/photo-1520813792240-56fc4a3765a7?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=4&w=256&h=256&q=60',
  },
  {
    name: 'Jenny Wilson',
    email: 'jenny.wilson@example.com',
    title: 'Central Security Manager',
    department: 'Program',
    status: 'Pending',
    role: 'Member',
    age: 29,
    imgUrl: 'https://images.unsplash.com/photo-1498551172505-8ee7ad69f235?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=4&w=256&h=256&q=60',
  },
  {
    name: 'Kristin Watson',
    email: 'kristin.watson@example.com',
    title: 'Lean Implementation Liaison',
    department: 'Mobility',
    status: 'Sandbox',
    role: 'Admin',
    age: 36,
    imgUrl: 'https://images.unsplash.com/photo-1532417344469-368f9ae6d187?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=4&w=256&h=256&q=60',
  },
  {
    name: 'Cameron Williamson',
    email: 'cameron.williamson@example.com',
    title: 'Internal Applications Engineer',
    department: 'Security',
    status: 'Done',
    role: 'Member',
    age: 24,
    imgUrl: 'https://images.unsplash.com/photo-1566492031773-4f4e44671857?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=4&w=256&h=256&q=60',
  },
]

const columns2 = [
  {
    Header: 'Name',
    accessor: 'name',
    Cell: AvatarCell,
    imgAccessor: 'imgUrl',
    emailAccessor: 'email',
  },
  {
    Header: 'Title',
    accessor: 'title',
  },
  {
    Header: 'Status',
    accessor: 'status',
    Cell: StatusPill,
    Filter: SelectColumnFilter,
    filter: 'includes',
  },
  {
    Header: 'Age',
    accessor: 'age',
  },
  {
    Header: 'Role',
    accessor: 'role',
    // Filter: SelectColumnFilter,
    // filter: 'includes',
  },
]

const status = {
  PROCESSING: 'PROCESSING',
  EDIT: 'EDIT',
  DONE: 'DONE',
  ERROR: 'ERROR',
}

const data = [
  {
    'site': {
      id: 3,
      name: 'Site 2'
    },
    'id': 3,
    'visit_date': 1626787541,
    'scan_id': 3,
    'biomarker': {
      'id': 1,
      'name': 'CST',
      'description': 'Central Subfield Thickness'
    },
    'status': 'DONE',
    'patient_id': 'Patient 2'
  },
  {
    'site': {
      id: 3,
      name: 'Site 2'
    },
    'id': 4,
    'visit_date': 1626787541,
    'scan_id': 4,
    'biomarker': {
      'id': 1,
      'name': 'CST',
      'description': 'Central Subfield Thickness'
    },
    'status': 'EDIT',
    'patient_id': 'Patient 3'
  },
  {
    'site': {
      id: 3,
      name: 'Site 2'
    },
    'id': 5,
    'visit_date': 1626787541,
    'scan_id': 5,
    'biomarker': {
      'id': 1,
      'name': 'CST',
      'description': 'Central Subfield Thickness'
    },
    'status': 'PROCESSING',
    'patient_id': 'Patient 4'
  },
  {
    'site': {
      id: 3,
      name: 'Site 2'
    },
    'id': 6,
    'visit_date': 1626787541,
    'scan_id': 6,
    'biomarker': {
      'id': 1,
      'name': 'CST',
      'description': 'Central Subfield Thickness'
    },
    'status': 'ERROR',
    'patient_id': 'Patient 5'
  },
  {
    'site': {
      id: 3,
      name: 'Site 2'
    },
    'id': 7,
    'visit_date': 1626787541,
    'scan_id': 7,
    'biomarker': {
      'id': 1,
      'name': 'CST',
      'description': 'Central Subfield Thickness'
    },
    'status': 'DONE',
    'patient_id': 'Patient 6'
  },
  {
    'site': {
      id: 3,
      name: 'Site 2'
    },
    'id': 8,
    'visit_date': 1626787541,
    'scan_id': 8,
    'biomarker': {
      'id': 1,
      'name': 'CST',
      'description': 'Central Subfield Thickness'
    },
    'status': 'EDIT',
    'patient_id': 'Patient 7'
  },
  {
    'site': {
      id: 3,
      name: 'Site 2'
    },
    'id': 9,
    'visit_date': 1626787541,
    'scan_id': 9,
    'biomarker': {
      'id': 1,
      'name': 'CST',
      'description': 'Central Subfield Thickness'
    },
    'status': 'PROCESSING',
    'patient_id': 'Patient 8'
  },
  {
    'site': {
      id: 3,
      name: 'Site 2'
    },
    'id': 9,
    'visit_date': 1626787541,
    'scan_id': 9,
    'biomarker': {
      'id': 1,
      'name': 'CST',
      'description': 'Central Subfield Thickness'
    },
    'status': 'ERROR',
    'patient_id': 'Patient 8'
  },

]

const columns = [
  {
    Header: 'Retinsight Id',
    accessor: 'retticket',
  },
  {
    Header: 'Patient Id',
    accessor: 'patient_id',
  },
  {
    Header: 'VRC Ticket Id',
    accessor: 'vrc_ticket_id',
  },
  {
    Header: 'Visit Date',
    accessor: 'visit_date',
    Cell: UnixtimeDateCell,
  },
  {
    Header: 'cst',
    accessor: 'cst.data',
    Cell: ({ value, column, row }) => {
      const cstValue = value ? `${value} µm` : null
      const pdfUrl = row?.original?.cst_pdf_file?.presigned_url
      const showPdfIcon = pdfUrl
        ? (
          <div className="relative w-6 h-6 justify-end ml-1 group">
            <IconSvg />
            <CloudDownloadIcon
              className="absolute w-4 h-4 invisible group-hover:visible"
              style={{
                top: '25%',
                right: '-1.2em',
              }}
            />
          </div>
        )
        : null
      const className = "rounded-lg hover:bg-green-200 flex justify-center text-sm text-gray-900 font-bold"
      if (showPdfIcon) {
        return (
          <a
            href={pdfUrl}
            className={className}
            onClick={(e) => {
              e.stopPropagation()
              // e.preventDefault()
              // console.log("-- A CST CLICKED")
              return false
            }}
          >
            <div className="self-center">{cstValue}</div>
            {showPdfIcon}
          </a>
        )
      }
      return (
        <div className={className}>
          <div className="self-center">{cstValue}</div>
        </div>
      )
    },
  },
  {
    Header: 'Status',
    accessor: 'status',
    Cell: StatusPill,
    Filter: SelectColumnFilter,
    filter: 'includes',
  },
]

const annotations = [
  {
    type: "layer",
    biomarker: "ilm",
    color: '#00ffff',
    data: [
      139,138,138,138,139,139,139,139,139,139,138,138,138,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,138,138,138,138,138,138,138,138,137,138,138,138,138,138,138,138,138,138,138,138,138,138,138,138,138,138,139,139,139,139,139,139,139,139,139,139,139,139,139,139,139,139,139,139,139,139,139,139,139,140,140,140,140,141,141,141,140,140,140,140,140,140,140,141,141,141,141,141,141,141,141,141,142,142,142,142,142,142,141,141,141,141,142,142,142,142,142,142,142,142,142,142,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,144,144,144,144,144,144,144,143,143,143,143,143,143,143,143,143,143,143,143,143,144,144,144,144,144,143,143,143,144,144,144,144,144,144,144,144,144,144,144,144,144,144,144,144,144,144,144,144,144,144,144,143,143,143,143,143,143,143,143,143,144,144,144,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,143,144,144,144,144,144,144,144,144,144,144,144,144,144,144,144,144,144,144,144,144,144,144,144,144,144,144,144,144,144,143,143,143,143,143,143,142,142,142,142,142,142,142,142,142,142,142,142,142,141,141,141,141,141,141,141,141,141,141,141,141,141,141,141,141,140,140,140,140,140,140,140,140,140,140,140,140,140,139,139,139,139,139,139,139,139,138,138,138,138,138,138,138,137,137,137,137,137,137,137,137,137,136,136,136,136,136,136,135,135,135,135,135,134,134,134,134,134,133,133,133,133,132,132,132,132,131,131,131,131,130,130,130,129,129,129,129,129,129,128,128,127,127,126,126,125,125,125,124,124,123,123,122,121,121,120,119,119,118,117,116,116,115,114,113,113,112,111,110,110,109,109,108,107,106,106,105,104,103,102,101,100,99,98,97,95,95,94,93,92,92,91,91,91,90,90,90,89,89,89,88,88,88,88,87,87,87,87,86,86,86,85,85,84,84,83,83,83,83,83,83,82,82,82,82,81,81,81,81,80,80,80,80,80,79,79,79,79,79,78,78,78,77,77,77,76,76,76,75,75,74,74,73,73,73,73,73,73,73,73,73,72,72,72,72,72,72,72,72,72,72,73,72,72,72,72,72,72,72,72,72,73,73,73,73,73,73,74,74,75,75,75,76,76,76,76,77,77,77,77,78,78,79,79,79,79,80,80,80,80,80,81,81,81,81,81,82,82,83,83,83,84,84,84,84,84,84,84,84,84,85,85,85,85,86,86,86,87,87,88,88,89,89,90,90,91,91,92,93,93,93,94,94,95,95,96,96,97,97,97,98,98,99,99,100,100,101,101,102,102,102,103,103,104,104,105,105,106,106,107,107,108,108,108,108,108,108,109,109,109,110,110,110,111,112,112,112,112,113,113,114,115,115,116,116,116,117,117,117,118,119,119,120,120,121,121,122,122,123,123,123,123,123,124,124,124,124,125,125,125,125,125,125,126,126,126,126,126,127,127,127,128,128,128,128,128,129,129,129,130,130,130,130,131,131,131,131,131,131,132,132,132,132,132,132,132,133,133,133,133,133,133,133,134,134,134,134,134,134,134,134,134,135,135,135,135,135,135,135,135,135,135,135,136,136,136,136,136,136,136,136,136,136,136,136,136,136,136,136,136,136,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,138,138,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,137,136,136,136,136,136,136,136,136,136,136,136,136,136,136,136,136,136,136,136,136,136,136,135,136,136,136,136,136,136,136,136,135,135,135,135,135,135,135,135,135,135,135,135,135,135,135,135,135,135,135,135,135,135,135,135,135,134,134,134,134,135,134,134,134,134,134,134,134,134,134,134,134,134,134,134,134,134,133,133,133,133,133,133,133,133,133,133,133,133,133,133,133,133,133,133,133,133,133,133,132,132,131,131,131,130,129,128,124,119
    ]
  },
  {
    type: "layer",
    biomarker: "bm",
    color: '#ff0000',
    data: [
      211,211,211,212,213,213,213,213,213,213,213,213,213,213,213,213,213,214,214,214,214,214,214,214,214,214,215,215,215,215,215,215,215,215,215,215,215,215,216,216,216,216,216,216,216,216,216,216,216,216,216,216,216,216,217,217,217,217,217,217,217,217,217,217,217,217,217,217,218,218,218,218,218,218,218,218,219,219,219,219,218,219,219,219,219,219,219,219,219,219,219,219,219,220,220,220,220,220,220,220,220,220,220,220,220,221,221,221,221,221,221,221,221,221,221,221,221,221,221,221,221,222,222,222,222,222,222,222,222,222,222,222,222,222,222,222,222,222,222,222,223,223,223,223,223,223,223,223,223,223,223,223,223,223,223,223,223,223,223,223,223,223,224,224,224,224,224,224,224,224,224,224,224,224,225,225,225,225,225,225,225,225,225,225,225,225,226,226,226,226,226,226,226,226,226,226,226,226,226,227,227,227,227,227,227,227,227,227,227,227,227,228,228,228,228,228,228,228,228,228,228,228,228,229,229,229,229,229,229,229,229,230,230,230,230,230,230,230,230,230,230,230,230,231,231,231,231,231,231,231,231,231,231,231,231,231,231,231,231,231,231,231,231,231,231,231,232,232,232,232,232,232,232,232,232,232,232,232,232,232,232,232,232,232,232,232,232,232,233,233,233,233,233,233,233,234,234,234,234,234,234,234,234,235,235,235,235,235,235,235,235,235,235,235,235,235,235,235,235,235,235,235,235,235,235,235,235,235,235,236,236,236,236,236,236,236,236,236,236,236,236,236,235,235,235,235,235,235,235,235,236,235,235,235,236,236,236,236,236,236,236,236,236,236,236,236,236,236,236,236,236,236,236,236,236,236,236,236,236,236,237,237,237,237,237,237,237,237,237,237,237,237,237,237,237,237,237,237,237,237,236,236,236,236,236,236,236,235,235,235,235,235,235,235,234,234,234,234,234,234,234,234,234,234,234,234,234,234,234,234,234,234,234,234,234,234,234,234,234,234,234,234,235,235,235,236,236,236,236,237,237,237,238,238,238,238,238,238,238,238,238,238,238,238,238,238,238,238,238,238,238,238,238,237,237,237,237,237,237,237,237,236,236,236,236,236,236,236,236,236,236,236,236,235,235,235,235,235,235,235,235,235,235,234,234,234,234,234,234,233,233,233,233,233,233,233,233,233,232,232,232,232,231,231,231,231,231,231,231,231,231,231,231,231,231,231,230,230,231,231,231,231,232,232,232,232,232,232,232,232,232,232,232,233,233,233,233,234,234,234,234,234,234,234,234,234,234,234,234,234,234,234,233,233,233,233,232,232,232,232,232,232,232,231,231,231,231,230,230,230,230,230,230,230,230,230,229,229,229,229,229,228,228,228,228,228,228,228,228,228,227,227,227,227,227,227,227,227,227,227,227,227,227,227,226,226,226,226,227,227,227,226,226,226,226,226,226,226,226,226,226,226,226,226,226,225,225,225,225,225,225,224,224,224,224,224,224,224,224,224,224,224,224,224,224,224,224,224,224,224,223,223,223,223,223,223,223,223,223,223,223,223,223,223,223,223,223,223,223,223,223,223,223,223,223,223,223,223,223,223,223,223,223,223,223,223,223,223,223,223,223,223,223,223,223,223,223,223,223,222,222,222,222,222,222,222,222,222,222,222,222,222,222,222,222,222,222,222,222,222,222,222,222,222,222,222,222,222,222,222,222,222,222,222,222,222,222,222,222,222,222,222,222,222,222,222,222,221,221,221,221,221,221,221,221,221,221,221,221,221,221,220,220,220,220,220,220,220,220,219,219,219,219,219,219,219,219,219,219,219,219,218,218,218,218,218,218,218,218,217,217,217,217,217,217,217,217,217,217,217,217,217,216,216,216,216,216,216,216,215,215,215,215,215,215,215,215,215,215,215,215,214,214,214,214,214,214,214,214,214,213,213,213,213,213,213,213,213,213,213,212,212,212,212,212,212,212,211,211,211,211,211,211,211,211,211,211,211,210,210,210,210,210,210,210,210,209,209,209,209,209,209,209,209,209,208,208,208,208,208,208,208,208,208,208,208,207,207,207,207,207,207,207,207,206,206,206,206,206,206,206,206,206,206,206,206,205,205,205,205,205,205,205,205,205,205,205,205,204,204,204,204,204,204,204,204,204,204,204,203,203,203,203,203,203,203,203,203,203,202,202,202,202,202,202,202,202,202,202,202,201,201,201,201,201,201,201,201,201,200,200,200,200,200,200,200,200,200,200,200,200,199,199,199,199,199,199,199,199,199,199,198,198,198,198,198,198,198,198,197,197,197,197,197,197,197,197,196,197,198,198,198,196,195
    ]
  }
]


export {
  data,
  columns,
  annotations,
}
